import { render } from "./Chartingresosegresos.vue?vue&type=template&id=36ed68bb"
import script from "./Chartingresosegresos.vue?vue&type=script&lang=js"
export * from "./Chartingresosegresos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__